import { render, staticRenderFns } from "./CreditBackView.vue?vue&type=template&id=5fcf892c&scoped=true"
import script from "@/scripts/creditback/creditBackView.js?vue&type=script&lang=js&external"
export * from "@/scripts/creditback/creditBackView.js?vue&type=script&lang=js&external"
import style0 from "./CreditBackView.vue?vue&type=style&index=0&id=5fcf892c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf892c",
  null
  
)

export default component.exports